<template>
    <modal v-model="opened" :transition='0' :append-to-body="true" :backdrop="false" class="set-name-popup">
        <template #header>
            <div>
                <a id="close_popup" @click="closePopup"></a>
                <h3 class="modal-title">{{header}}</h3>
            </div>
        </template>
        <div class="row margin-15-bottom">
            <div class="col-sm-12">
                Please add your first name and last name so other users can easily identify you on Multi Me.
            </div>
        </div>
        <div class="row margin-15-bottom">
            <div class="col-sm-12">
                <div>
                    <span>First Name:</span>
                    <input ref="name-input" v-model="firstName" maxlength="100" type="text" class="form-control"
                           placeholder="First Name"
                           required/>
                </div>
            </div>
        </div>
        <div class="row margin-15-bottom">
            <div class="col-sm-12">
                <div>
                    <span>Last Name:</span>
                    <input ref="name-input" v-model="lastName" maxlength="100" type="text" class="form-control"
                           placeholder="Last Name"
                           required/>
                </div>
            </div>
        </div>

        <template #footer>
            <div>
                <div class="row">
                    <div class="col-xs-12 ">
                        <button class="btn btn-mm" @click="closePopup"><i class="fa fa-times"></i> Remind me later</button>
                        <button class="btn btn-mm btn-green save-button" @click="save" :disabled="!allowSave">
                            <i class="fa fa-check"></i> Save
                        </button>
                    </div>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
    import {CurrentUserClass} from "../shared/CurrentUser";

    export default {
        name: "SetFirstLastNamePopup",
        data() {
            return {
                firstName: '',
                lastName: '',
                opened: false,
                username: '',
            };
        },
        computed: {
            header() {
                const cu = new CurrentUserClass();
                const username = cu.first_name || cu.username;
                return `Hello ${username}`;
            },
            allowSave() {
                return this.firstName && this.lastName;
            }
        },
        methods: {
            closePopup() {
                this.opened = false;
                this.reject();
            },
            show() {
                this.opened = true;
                return new Promise((res, rej) => {
                    this.resolve = res;
                    this.reject = rej;
                });
            },
            save() {
                this.opened = false;
                this.resolve({first_name: this.firstName, last_name: this.lastName});
            }
        }
    };
</script>

<style scoped lang="scss">
    @use "../styles/const" as *;

    .set-name-popup {
        font-size: $bigger-font-size;
    }
</style>